/*
	CHARACTERS
*/
//------------------------------------------------------------
// IMPORT
//------------------------------------------------------------

import Character from './Character.js';
import mainCharacters from './mainCharacters.js';
import randomCharacters from './randomCharacters.js';

//------------------------------------------------------------
// PEOPLE DATABASE
//------------------------------------------------------------

const characters = [
	...mainCharacters,
	...randomCharacters

	// { name: 'Xx JERICHO Xx', status: 'away' },
	// { name: 'ATOM', status: 'online' },
	// { name: 'gwendolyn', status: 'online' },
	// { name: 'elvie', status: 'n/a' },
	// { name: 'FROSTBYTE', status: 'online' },
	// { name: 'Kloudi', status: 'offline' },
	// { name: 'AJ', status: 'offline' },
	// { name: 'mike cullen', status: 'offline' },
	// { name: 'onna', status: 'offline' },
	// { name: 'Hematoma', status: 'offline' },
	// { name: 'somereallyreallylongnameahahahahahahaha', status: 'offline' },
	// { name: 'Jillion', status: 'offline' },
	// { name: 'Nathan', status: 'offline' },
	// { name: 'SynthLOCK', status: 'offline' }
];

//------------------------------------------------------------
// EXPORTS
//------------------------------------------------------------

export default characters;
